/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_Description_PlaceholderInputs */

const en_task_field_description_placeholder = /** @type {(inputs: Task_Field_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provide clear steps for the assignee to follow…`)
};

const pt_br2_task_field_description_placeholder = /** @type {(inputs: Task_Field_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forneça instruções claras para o responsável…`)
};

/**
* | output |
* | --- |
* | "Provide clear steps for the assignee to follow…" |
*
* @param {Task_Field_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_description_placeholder = /** @type {((inputs?: Task_Field_Description_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_Description_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_description_placeholder(inputs)
	return pt_br2_task_field_description_placeholder(inputs)
});